import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

function SECDialogBar({ handleClose, handleSave, title, showSave = true }) {

    return (
      <AppBar position="sticky">
        <Toolbar sx={{ backgroundColor: "#0c1e35" }}>
          <IconButton
            id="close"
            data-testid="close"
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {title}
          </Typography>
          {showSave && (
            <Button
              id="save"
              data-testid="save"
              autoFocus
              color="inherit"
              onClick={handleSave}
            >
              save
            </Button>
          )}
        </Toolbar>
      </AppBar>
    );
}

export default SECDialogBar;